<template>
  <div class="CorpInfo">
    <!-- 当前位置 -->
    <div class="container">
      <div class="content" >
        <div class="sys">
          <h1>报装联系电话：029-86913691</h1>
          <h1>报修联系电话：029-86911044</h1>
          <h1>水费查询电话：029-86913642</h1>
          <h1>联系地址：陕西省西安市高陵区北广场路500号</h1>
        </div>
        <img :src="corpaddr" alt style="width:100%;height:300px;" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      corpaddr: undefined
    }
  },
  created(){
    this.corpaddr = require('@/assets/image/corpaddr.png')
  },
  methods:{
  }
};
</script>



<style lang="less" scoped>
p {
  color: #666666;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 25px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 6px;
}
h4 {
  color: #333333;
  font-size: 18px;
}
.CorpInfo {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #dd2126;
}

.top {
  margin-top: 24px;
  margin-bottom: 30px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #dd2126;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  line-height: 34px;
  color: white;
}
.content {
  width: 1200px;
  min-height: 420px;
  background-color: white;
  box-sizing: border-box;
  padding: 26px 40px;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.er{
  width: 920px;
overflow-wrap: break-word;
}
</style>